const productLinks = {
  women: {
    'AERO GLIDE 4 GRVL W': 'https://salomon.jp/products/aero-glide-4-grvl-l454073',
    'AERO BLAZE 4 GRVL GORE-TEX W': 'https://salomon.jp/collections/aero-blaze-4-grvl/products/aero-blaze-4-grvl-gtx-l454039',
    'AERO BLAZE 4 GRVL W': 'https://salomon.jp/collections/aero-blaze-4-grvl/products/aero-blaze-4-grvl-l454019',
    'AERO FLOW GRVL GORE-TEX W': 'https://salomon.jp/collections/sports-gravel-running/products/aero-flow-grvl-gore-tex-l453922',
    'AERO FLOW GRVL W': 'https://salomon.jp/collections/fw-collection-gravel/products/aero-flow-grvl-l453926',
    'BONATTI WATERPROOF JKT W': 'https://salomon.jp/collections/fw-collection-gravel/products/bonatti-waterproof-lc29326',
    'SHKout FLY JKT W': 'https://salomon.jp/collections/fw-collection-gravel/products/shakeout-fly-lc29507',
    'SENSE MERINO LS TEE W': 'https://salomon.jp/products/sense-merino-lc29450',
    'SHKout CORE LS TEE W': 'https://salomon.jp/collections/women-tops-tees/products/shakeout-core-lc29504',
    'SHKout CORE LS TEE GFX W': 'https://salomon.jp/collections/fw-collection-gravel/products/shakeout-core-graphic-lc29506',
    'SHKout CORE SS TEE W': 'https://salomon.jp/collections/fw-collection-gravel/products/shakeout-core-lc29503',
    'SHKout CORE SS TEE GFX W': 'https://salomon.jp/collections/fw-collection-gravel/products/shakeout-core-graphic-lc30407',
    'SENSE AERO STOW 4 W': 'https://salomon.jp/products/sense-aero-stow-4-lc27796',
    'SHKout CORE SHORTS 4 W': 'https://salomon.jp/products/shakeout-core-lc29486'
  },
  men: {
    'AERO GLIDE 4 GRVL': 'https://salomon.jp/collections/fw-collection-gravel/products/aero-glide-4-grvl-l492275',
    'AERO BLAZE 4 GRVL GORE-TEX': 'https://salomon.jp/collections/aero-blaze-4-grvl/products/aero-blaze-4-grvl-gtx-l454032',
    'AERO BLAZE 4 GRVL': 'https://salomon.jp/collections/aero-blaze-4-grvl/products/aero-blaze-4-grvl-l454005',
    'AERO FLOW GRVL GORE-TEX': 'https://salomon.jp/collections/sports-gravel-running/products/aero-flow-grvl-gore-tex-l453919',
    'AERO FLOW GRVL': 'https://salomon.jp/collections/sports-gravel-running/products/aero-flow-grvl-l453926',
    'BONATTI PRO JKT M': 'https://salomon.jp/products/bonatti-pro-lc27698',
    'SHKout FLY JKT M': '',
    'SENSE MERINO LS TEE M': 'https://salomon.jp/collections/fw-collection-gravel/products/sense-merino-lc29457',
    'SHKout CORE LS TEE M': 'https://salomon.jp/products/shkout-core-lc24244',
    'SHKout CORE LS TEE GFX M': 'https://salomon.jp/collections/men-tops-tees/products/shakeout-core-graphic-lc29478',
    'SHKout CORE SS TEE M': 'https://salomon.jp/collections/fw-collection-gravel/products/shakeout-core-lc29476',
    'SHKout CORE SS TEE GFX M': 'https://salomon.jp/collections/men-tops-tees/products/shakeout-core-graphic-lc30408',
    'SENSE AERO STOW 5 M': 'https://salomon.jp/collections/fw-collection-gravel/products/sense-aero-stow-lc29316',
    'SHKout CORE SHORTS 5 M': 'https://salomon.jp/products/shkout-core-5-lc24504'
  },
  unisex: {
    'GRVL CONCEPT': 'https://salomon.jp/collections/fw-collection-gravel/products/grvl-concept-l454104',
    'SENSE AERO CAP GFX U': 'https://salomon.jp/collections/fw-collection-gravel/products/sense-aero-graphic-lc30143',
    'BANDANA GFX U': 'https://salomon.jp/products/salomon-bandana-graphic-lc29528',
    'GRVL CREW': 'https://salomon.jp/products/grvl-crew-lc30665',
    'GRVL SKIN 4 SET': 'https://salomon.jp/collections/men-bags-packs-running-packs-and-belts/products/grvl-skin-4-lc28548',
    'GRVL CONCEPT SKIN 2 SET': 'https://salomon.jp/collections/sports-gravel-running-bags-and-belts/products/grvl-concept-skin-2-lc28713'
  }
};

const productGroups = [
  ['.women', 'women'],
  ['.women-apparel', 'women'],
  ['.men', 'men'],
  ['.men-apparel', 'men'],
  ['.unisex-shoes', 'unisex'],
  ['.unisex-accessories', 'unisex'],
  ['.bag-products', 'unisex']
];

productGroups.forEach(([selector, group]) => {
  document.querySelectorAll(`${selector} .product-card`).forEach((card) => {
    const productName = card.querySelector('h4')?.textContent.trim();
    const link = productLinks[group][productName];

    if (link) {
      card.href = link;
      card.target = '_blank';
      card.rel = 'noopener noreferrer';
      return;
    }

    card.removeAttribute('href');
    card.classList.add('product-card--coming-soon');
    card.setAttribute('aria-disabled', 'true');
    card.setAttribute('tabindex', '-1');
  });
});
